import { RootEpic } from 'MyTypes';
import { from, of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { isActionOf } from 'typesafe-actions';

import {
    REDIRECTION_SESSION,
    deleteCookie,
    setTopLevelDomainCookie,
} from '@portal/common/utility/cookies';
import { ensureDateIsUTC } from '@portal/common/utility/formatting/ensureDateIsUTC';

import { getLocalStorageItem, removeLocalStorageItem } from '../../services/localStorageService';
import { getOrganizationAsync } from './actions';

const redirectToSubdomain = (res) => {
    if (
        import.meta.env.VITE_ENV !== undefined &&
        res.domain_prefix &&
        !window.location.href.includes(res.domain_prefix)
    ) {
        const domain = window.location.hostname.split(/\./).slice(-2).join('.');

        setTopLevelDomainCookie({
            name: REDIRECTION_SESSION,
            value: JSON.stringify(getLocalStorageItem('redux')),
        });
        removeLocalStorageItem('redux');
        window.location.href = `https://${res.domain_prefix}.${domain}`;
    } else {
        deleteCookie(REDIRECTION_SESSION);
    }
};

export const loadOrganization: RootEpic = (action$, state$, dependencies) => {
    const { api } = dependencies;
    return action$.pipe(
        filter(isActionOf([getOrganizationAsync.request])),
        switchMap(() =>
            from(api.organization.getOrganization()).pipe(
                map((res) => {
                    redirectToSubdomain(res);
                    if (res.licensed_until) {
                        res.licensed_until = ensureDateIsUTC(res.licensed_until);
                    }
                    return getOrganizationAsync.success(res);
                }),
                catchError((message: string) => of(getOrganizationAsync.failure(message)))
            )
        )
    );
};
